/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { GetterTree } from 'vuex';
import * as types from '@/store/types';
import { BricksState } from './models';
import { RootState } from '../models';

export const getters: GetterTree<BricksState, RootState> = {
  [types.GET_LOADING](state): BricksState['loading'] {
    return state.loading;
  },

  [types.GET_AVAILABLE_BRICKS](state): BricksState['bricks'] {
    const allbricks: BricksState['bricks'] = state.bricks;
    return allbricks;
  },
  [types.GET_BRICK_NAMES](state): BricksState['bricks'] {
    const { selectedBricks } = state;
    // eslint-disable-next-line no-nested-ternary
    return selectedBricks.sort((a, b) => ((a.name > b.name) ? 1 : (b.name > a.name ? -1 : 0)));
  },
  [types.GET_BRICK_TYPES](state): any {
    const brickTypes : String[] = [];
    for (const br of state.selectedBricks) {
      if (brickTypes.indexOf(br.family) === -1) brickTypes.push(br.family);
    }
    return brickTypes;
  },
  [types.GET_ADD_BRICK_LOADING](state): BricksState['addLoading'] {
    return state.addLoading;
  },
  [types.GET_ADD_BRICK_ERROR](state): BricksState['addErrMsg'] {
    return state.addErrMsg;
  },
  [types.GET_ADD_BRICK_SUCCESS](state): BricksState['addSuccess'] {
    return state.addSuccess;
  },
  [types.GET_PACKAGES](state): BricksState['packages'] {
    const pacakges = state.packages;

    const sortedPackages = pacakges.sort((a: any, b: any) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sortedPackages;
  },
};
